<template>
  <div>
    <!-- <mk-form v-if="formList!=null" :list="formList" :formvalue="formvalue"></mk-form> -->
    <div id="charts" style="height:500px;width:100%;"></div>
    <div class="chart chart--line" title="转换为折线图" @click="lineChart">
      <img src="../assets/imgs/ico32_15.png" style="width:25px;height:25px;" alt />
    </div>
    <div class="chart chart--bar" title="转换为柱状图" @click="barChart">
      <img src="../assets/imgs/ico32_16.png" style="width:25px;height:25px;" alt />
    </div>
    <div class="chart chart--pie" title="转换为饼图" @click="pieChart">
      <img src="../assets/imgs/ico32_19.png" style="width:25px;height:25px;" alt />
    </div>
    <div class="chart chart--set" title="图形设置" @click="setChart">
      <img src="../assets/imgs/ico32_14.png" style="width:25px;height:25px;" alt />
    </div>
    <!-- 设置图表 -->
    <el-dialog id="chatSettingLog" title="图形设置" :visible.sync="dialogChartSetting" width="1000px">
      <!-- 选项 -->
      <div>
        <!-- 选项 -->
        <el-form ref="form" :model="form" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="图表标题：">
                <el-input v-model="form.chartTitle" placeholder="请输入标题" style="width:200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图例位置：">
                <el-select v-model="form.chartLocation" placeholder="请选择" style="width:200px;">
                  <el-option
                    v-for="item in location"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="X轴间隔：">
              <el-select v-model="form.intervalNum" placeholder="请选择" style="width:200px;">
                <el-option
                  v-for="item in intervalNums"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
               </el-form-item>
              <!-- <el-form-item label="X轴间隔：">
                <el-input-number v-model="form.intervalNum" :min="0"  label="描述文字"></el-input-number>
              </el-form-item>-->
            </el-col>
            <el-col :span="12">
              <el-form-item label="X轴周期：">
                <el-input-number v-model="form.periodNum" :min="1" :max="maxXdata" label="描述文字"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="左Y轴名称：">
                <el-input
                  v-model="form.ylTitle"
                  placeholder="请输入标题"
                  style="width:200px;"
                  :disabled="ylDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="右Y轴名称：">
                <el-input
                  v-model="form.yrTitle"
                  placeholder="请输入标题"
                  style="width:200px;"
                  :disabled="yrDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="左Y轴初始值：">
                <el-input
                  v-model="form.ylInitialVal"
                  placeholder="请输入数值"
                  type="number"
                  style="width:200px;"
                  :disabled="ylInitialDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="右Y轴初始值：">
                <el-input
                  v-model="form.yrInitialVal"
                  placeholder="请输入数值"
                  type="number"
                  style="width:200px;"
                  :disabled="yrInitialDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-form-item style="margin-left:-100px;">
            <!-- <input type="hidden" v-model="form.selectChart" /> -->
            <div style="overflow-y:auto;height:242px;width: 94%;margin: 0 auto;">
              <table id="echart__table">
                <tr>
                  <th>
                    <!--    -->
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                    >全选</el-checkbox>
                  </th>
                  <th>序列名称</th>
                  <th>图例名称</th>
                  <th style="width:100px;">类型</th>
                  <th style="width:75px;">Y轴位置</th>
                  <th>颜色</th>
                </tr>
                <tr v-for="(item,index) in defalutChart" :key="index">
                  <td>
                    <el-checkbox v-model="item.checked" @change="checkOne(item.checked)"></el-checkbox>
                  </td>
                  <td>{{item.name}}</td>
                  <td>
                    <!-- <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.name"></el-input> -->
                    {{item.name}}
                  </td>
                  <td>
                    <el-select v-model="item.type" placeholder="请选择">
                      <el-option
                        v-for="item in chartType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-select v-model="item.yValue" placeholder="请选择">
                      <el-option
                        v-for="item in yaxis"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-color-picker v-model="item.color" show-alpha :predefine="predefineColors"></el-color-picker>
                  </td>
                </tr>
              </table>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 提交 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChartSetting = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      option: {
        // 标题
        title: {
          text: ""
        },
        // 工具栏。
        toolbox: {
          right: 10,
          itemGap: 15, // 工具栏 icon 每项之间的间隔
          // itemSize: 15, // 工具栏 icon 的大小
          feature: {
            saveAsImage: {}, // 保存图片
            // dataView: {} // 数据表格展示
          }
        },
        // 提示框组件
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "5%",
          top: "10%",
          containLabel: true
        },
        legend: {
          top: "",
          data: []
        },
        series: []
        // xAxis.axisLabel.interval  X轴间隔
      },
      dialogChartSetting: false,
      form: {
        chartTitle: "",
        chartLocation: "",
        intervalNum: 'auto',
        periodNum: this.chartdata.xAxis.length,
        ylTitle: "",
        yrTitle: "",
        ylInitialVal: "",
        yrInitialVal: ""
      },
      maxXdata: this.chartdata.xAxis.length,
      selectChart: [],
      location: [
        { value: "top", label: "上" },
        { value: "bottom", label: "下" }
      ],
       intervalNums: [{
          value: 1,
          label: 'auto'
        }, {
          value: 2,
          label: '2'
        }, {
          value: 3,
          label: '4'
        }, {
          value: 4,
          label: '6'
        }, {
          value: 5,
          label: '8'
        }, {
          value: 6,
          label: '10'
        }],

      ylDisabled: false,
      yrDisabled: false,
      ylInitialDisabled: false,
      yrInitialDisabled: false,
      // 渲染表格的数据
      defalutChart: [],
      chartType: [
        { value: "line", label: "折线图" },
        { value: "bar", label: "柱状图" },
        { value: "pie", label: "饼状图" }
      ],
      yaxis: [{ value: "left", label: "左" }, { value: "right", label: "右" }],
      predefineColors: [
        "#5D91A7",
        "#00516C",
        "#00A4DC",
        "#6BCFF6",
        "#008982",
        "#6DBBBF",
        "#7A250F",
        "#EA8F74",
        "#A8A9AD"
      ],
      isIndeterminate: true,
      checkAll: false
      // 勾选的数据
      // drawchartData: this.chartdata
    };
  },
  props: {
    chartdata: Object
  },
  mounted() {
    this.drawLine_Bar(1);
  },
  watch: {
    chartdata: {
      handler: function(newval, oldval) {
        // console.log(this.periodNum,'periodNum')
        // 每次chartdata更新清空defalutChart中的数据
        (this.form = {
          chartTitle: "",
          chartLocation: "",
          intervalNum: 'auto',
          periodNum: this.chartdata.xAxis.length,
          ylTitle: "",
          yrTitle: "",
          ylInitialVal: "",
          yrInitialVal: ""
        }),
          (this.defalutChart = []);
        newval.legend.forEach((item, index) => {
          this.defalutChart.push({
            checked: index === 0,
            name: item,
            type: "折线图",
            yValue: "左",
            color: this.predefineColors[index],
            data: newval.series[index]
          });
        });
        this.selectData();
      },
      deep: true,
      immediate: true
    },
    selectChart: {
      handler: function(newval, oldval) {
        // debugger;
        this.yrDisabled = this.selectChart.every(ele => {
          return ele.yValue === "左";
        });
        this.yrInitialDisabled = this.yrDisabled;
        this.ylDisabled = this.selectChart.every(ele => {
          return ele.yValue === "右";
        });
        this.ylInitialDisabled = this.ylDisabled;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 选择
    handleCheckAllChange(val) {
      this.defalutChart.forEach(item => {
        item.checked = val;
      });
      this.selectData();
    },
    checkOne() {
      let checkAll = this.defalutChart.every(item => {
        return item.checked === true;
      });
      let checkEvery = this.defalutChart.some(item => {
        return item.checked === true;
      });
      if (checkAll === true) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (checkEvery === true) {
        this.checkAll = false;
        this.isIndeterminate = true;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
      this.selectData();
    },
    // 勾选的数据
    selectData() {
      // debugger
      this.selectChart = [];
      this.defalutChart.forEach(item => {
        if (item.checked === true) {
          this.selectChart.push(item);
        }
      });
    },
    lineChart() {
      this.drawLine_Bar(2);
    },
    barChart() {
      this.drawLine_Bar(3);
    },
    // 画折线图/柱状图
    drawLine_Bar(param) {
      // debugger
      let line_barOption = JSON.parse(JSON.stringify(this.option));
      // 组装数据
      line_barOption.xAxis = [
        {
          type: "category",
          boundaryGap: true,
          axisTick: {
            alignWithLabel: true
          },
          data: this.chartdata.xAxis
        }
      ];
      line_barOption.yAxis = [
        {
          type: "value",
          scale: true
        }
      ];
      line_barOption.series = [];
      line_barOption.legend.data = [];
      line_barOption.color = [];
      line_barOption.title.text = this.form.chartTitle;
      line_barOption.legend.top = this.form.chartLocation;

      if (param === 1) {
        line_barOption.legend.data.push(this.chartdata.legend[0]);
        line_barOption.color.push(this.selectChart[0].color);
        line_barOption.series.push({
          name: this.chartdata.legend[0],
          type: "line",
          data: this.chartdata.series[0]
        });
        // console.log(line_barOption,'line_barOption')
      } else if (param === 2) {
        this.selectChart.forEach(item => {
          line_barOption.color.push(item.color);
          line_barOption.series.push({
            name: item.name,
            type: "line",
            data: item.data
          });
          line_barOption.legend.data.push(item.name);
        });
      } else if (param === 3) {
        this.selectChart.forEach(item => {
          line_barOption.color.push(item.color);
          line_barOption.series.push({
            name: item.name,
            type: "bar",
            data: item.data
          });
          line_barOption.legend.data.push(item.name);
        });
      } else if (param === 4) {
        // 中文转换英文
        let newData = JSON.parse(JSON.stringify(this.selectChart));
        newData.forEach(item => {
          item.yValue === "左"
            ? (item.yValue = "left")
            : (item.yValue = "right");
          item.type === "折线图"
            ? (item.type = "line")
            : item.type === "柱状图"
            ? (item.type = "bar")
            : (item.type = "pie");
        });
        line_barOption.xAxis[0].axisLabel = { interval: this.form.intervalNum };

        line_barOption.xAxis[0].data = this.chartdata.xAxis.slice(
          this.chartdata.xAxis.length - this.form.periodNum,
          this.chartdata.xAxis.length
        );
        // line_barOption.yAxis = []

        // 判断是否有双Y轴
        let isLPair = newData.every(item => {
          return item.yValue === "left";
        });
        let isRPair = newData.every(item => {
          return item.yValue === "right";
        });
        let isPair = isLPair || isRPair;
        // 单Y轴
        if (isPair === true) {
          newData.forEach(item => {
            if (item.yValue === "left") {
              line_barOption.yAxis = {
                name: this.form.ylTitle,
                min:
                  this.form.ylInitialVal === "" ? null : this.form.ylInitialVal,
                position: item.yValue,
                scale: true
              };
            } else {
              line_barOption.yAxis = {
                name: this.form.yrTitle,
                min:
                  this.form.ylInitialVal === "" ? null : this.form.ylInitialVal,
                position: item.yValue,
                scale: true
              };
            }
            line_barOption.color.push(item.color);
            line_barOption.legend.data.push(item.name);
            line_barOption.series.push({
              name: item.name,
              type: item.type,
              yAxisIndex: 0,
              data: item.data.slice(
                this.chartdata.xAxis.length - this.form.periodNum,
                this.chartdata.xAxis.length
              ),
              lineStyle: { color: item.color }
            });
          });
        } else {
          // 双Y轴
          newData.forEach(item => {
            line_barOption.color.push(item.color);
            line_barOption.legend.data.push(item.name);
            line_barOption.yAxis[0] = {
              name: this.form.ylTitle,
              min:
                this.form.ylInitialVal === "" ? null : this.form.ylInitialVal,
              position: "left",
              scale: true
            };
            line_barOption.yAxis[1] = {
              name: this.form.yrTitle,
              min:
                this.form.yrInitialVal === "" ? null : this.form.yrInitialVal,
              position: "right",
              scale: true
            };
            if (item.yValue === "left") {
              line_barOption.series.push({
                name: item.name,
                type: item.type,
                yAxisIndex: 0,
                data: item.data.slice(
                  this.chartdata.xAxis.length - this.form.periodNum,
                  this.chartdata.xAxis.length
                ),
                lineStyle: { color: item.color }
              });
            } else {
              line_barOption.series.push({
                name: item.name,
                type: item.type,
                yAxisIndex: 1,
                data: item.data.slice(
                  this.chartdata.xAxis.length - this.form.periodNum,
                  this.chartdata.xAxis.length
                ),
                lineStyle: { color: item.color }
              });
            }
          });
        }
      }
      // 绘制图
      let mychart = this.$echarts.init(document.querySelector("#charts"));
      mychart.clear();
      mychart.setOption(line_barOption);
      // console.log(line_barOption);
      window.addEventListener("resize", mychart.resize);
    },
    pieChart() {
      // debugger
      let pieOption = {
        baseOption: {},
        options: []
      };
      pieOption.baseOption = JSON.parse(JSON.stringify(this.option));
      pieOption.baseOption.tooltip.trigger = "item";
      (pieOption.baseOption.timeline = {
        data: this.chartdata.xAxis,
        show: true,
        axisType: "category",
        autoPlay: true,
        label: {
          // formatter: function(s) {
          //   return new Date(s).getFullYear();
          // }
        },
        left: 20,
        right: 20
      }),
        (pieOption.baseOption.series = {
          name: "指数",
          type: "pie",
          center: ["50%", "50%"],
          radius: "28%"
        });
      for (let i = 0; i < this.chartdata.xAxis.length; i++) {
        pieOption.options.push({ series: [{ data: [] }] });
      }
      for (let i = 0; i < this.selectChart.length; i++) {
        for (let j = 0; j < this.chartdata.xAxis.length; j++) {
          pieOption.options[j].series[0].data.push({
            name: this.selectChart[i].name,
            value: this.selectChart[i].data[j],
            itemStyle: { color: this.selectChart[i].color }
          });
        }
      }
      // 画图
      let mychart = this.$echarts.init(document.querySelector("#charts"));
      mychart.clear();
      mychart.setOption(pieOption);
      window.addEventListener("resize", mychart.resize);
    },
    setChart() {
      // console.log(this.chartdata,'this.chartdata')
      // console.log(this.chartName,'this.chartName')
      this.dialogChartSetting = true;
      // 降低遮罩层的堆叠顺序
      setTimeout(() => {
        $(".v-modal").css("z-index", "2000");
      }, 10);
    },
    submit() {
      var findPie = this.selectChart.filter(item => item.type === "饼状图");
      if (findPie.length > 0 && findPie.length < this.selectChart.length) {
        this.$message({
          message: "饼状图 不能和其他图混合显示",
          type: "warning"
        });
        return;
      }
      if (findPie.length > 0) {
        this.pieChart();
      } else {
        this.drawLine_Bar(4);
      }
      this.dialogChartSetting = false;
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-dialog__body {
  padding: 15px 30px 0px 30px;
}
#echart__table {
  border-collapse: collapse;
  border: 1px solid #ccc;
  width: 100%;
  tr {
    th,
    td {
      border: 1px solid #ccc;
      text-align: center;
      line-height: 3.2;
      padding: 0px 5px;
    }
    td {
      vertical-align: middle;
      line-height: initial;
      padding: 2px 5px;
    }
  }
  .el-textarea {
    padding-bottom: 0px;
    vertical-align: bottom;
    .el-textarea__inner {
      padding: 0px;
      line-height: 1.32;
      font-family: auto;
      font-size: 13px;
    }
  }
}
// .dt__chart {
//   background: #fff;
//   position: relative;
// }
.chart {
  position: absolute;
  top: 15px;
  cursor: pointer;
}
.chart--pie {
  right: 230px;
}
.chart--bar {
  right: 180px;
}
.chart--line {
  right: 130px;
}
.chart--set {
  right: 80px;
}
.v-modal {
  z-index: 2000;
}
.el-col /deep/ .el-form-item__label {
  padding: 0px !important;
}
/deep/.el-dialog__title {
  font-weight: 600;
  color: #409eff;
}
.el-row {
  width: 74%;
  margin: 0 auto;
}
.el-input,
.el-select,
.el-input-number {
  display: block;
}
</style>